export const DICT = 'Dict';
